import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';

import { updateStatus } from '../../../horse-racing-shared/services/horses-fixture-helper.service';

@Component({
    selector: 'ms-race-time-status',
    templateUrl: './race-time-status.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class RaceTimeStatusComponent {
    @Input() race: WinGameFixture;
    @Input() isSports: boolean;
    @Input() timeInSeconds: number;
    @Input() status: string;
    @Input() isHomeRaceTime?: boolean;

    display = false;
    readonly maxChars = 30;

    constructor(public sitecore: Sitecore) {}

    onDisplay($event: boolean): void {
        this.display = $event;
    }

    updateStatus(fixture: WinGameFixture): string | undefined {
        return updateStatus(fixture, this.sitecore);
    }

    get textAfterTimerFinished(): string {
        return this.isSports ? this.sitecore.horseRacing.raceSummary.PostTime : (this.sitecore.betStation?.greyhoundRacing.messages.PostTime ?? '');
    }
}
